import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();
  
  return (
    <section id="about" className="py-20 bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl sm:text-6xl lg:text-7xl font-normal text-gray-900 mb-6 uppercase tracking-tight" style={{ fontFamily: 'Bebas Neue, Impact, sans-serif' }}>
            {t('about.title')}
          </h2>
          <div className="w-24 h-1 bg-amber-700 mx-auto mb-12"></div>
        </div>

        <div className="max-w-4xl mx-auto space-y-8 text-lg sm:text-xl lg:text-2xl text-gray-800 leading-relaxed">
          <p className="text-center font-semibold text-2xl sm:text-3xl text-gray-900">
            {t('about.subtitle1')}
          </p>

          <p>
            {t('about.p1')}
          </p>

          <p>
            {t('about.p2')}
          </p>

          <div className="py-6 space-y-2 text-center">
            <p className="text-xl sm:text-2xl font-bold text-amber-800">
              {t('about.highlight1')}
            </p>
            <p className="text-xl sm:text-2xl font-bold text-amber-800">
              {t('about.highlight2')}
            </p>
          </div>

          <p>
            {t('about.p3')}
          </p>

          <p className="text-center font-bold text-2xl sm:text-3xl text-gray-900 pt-6">
            {t('about.tagline')}
          </p>
        </div>
      </div>
    </section>
  );
}